/* FRX-43440: PDP Accelerated Checkout - Regular / VIP */

(() => {
  if (window.__frx43440WalletInitialized) return;
  window.__frx43440WalletInitialized = true;

  const EXTRA_FIELD = 'data-frx-43440-wallet-item';
  const EXTRA_PREFIX = 'shopify-additional-items[1]';

  function initForm(form) {
    if (form.dataset.frx43440Initialized === 'true') return;

    const wallet = form.querySelector('[data-frx-wallet]');
    const productInfo = form.closest('[id^="ProductInfo-"]');

    if (!wallet || !productInfo) return;

    const offer = productInfo.querySelector(
      '.vip-offer--pdp[data-vip-offer-container]'
    );

    // Product without VIP Pricing
    if (!offer) {
      form.dataset.frx43440Initialized = 'true';
      return;
    }

    const checkbox = offer.querySelector('.vip-offer__checkbox');

    const memberRadio = offer.querySelector(
      '[data-vip-price-option="member"]'
    );

    if (!checkbox || !memberRadio) {
      wallet.dataset.frxUnavailable = 'true';
      console.warn('[FRX-43440] VIP selector not found.');
      return;
    }

    form.dataset.frx43440Initialized = 'true';

    // Remove previously added membership fields
    function clearExtraFields() {
      form.querySelectorAll(`[${EXTRA_FIELD}]`).forEach((node) => {
        node.remove();
      });
    }

    // Add Shopify additional-item field
    function addHiddenField(key, value) {
      const input = document.createElement('input');

      input.type = 'hidden';
      input.name = `${EXTRA_PREFIX}[${key}]`;
      input.value = value;

      input.setAttribute(EXTRA_FIELD, '');

      form.appendChild(input);
    }

    // Existing active VIP customers do not need another membership
    function isExistingVipCustomer() {
      return (
        offer.dataset.vipOverride === 'true' ||
        offer.classList.contains('vip-offer--existing-vip')
      );
    }

    let lastPayload = null;

    function syncWalletItems() {
      if (!form.isConnected) return;

      const selectedVip = memberRadio.checked;

      const needsNewMembership =
        selectedVip && !isExistingVipCustomer();

      const variantId = String(
        checkbox.dataset.subscriberVariantId || ''
      ).trim();

      const sellingPlanId = String(
        checkbox.dataset.subscriberSellingPlanId || ''
      ).trim();

      const isValid =
        /^\d+$/.test(variantId) &&
        /^\d+$/.test(sellingPlanId);

      const payload = needsNewMembership
        ? (isValid ? `${variantId}:${sellingPlanId}` : 'INVALID')
        : 'REGULAR_OR_EXISTING_VIP';

      // Hide wallet if VIP subscription configuration is invalid
      if (payload === 'INVALID') {
        wallet.dataset.frxUnavailable = 'true';

        if (lastPayload !== payload) {
          console.warn(
            '[FRX-43440] VIP variant or selling plan is missing.'
          );
        }
      } else {
        wallet.removeAttribute('data-frx-unavailable');
      }

      if (payload === lastPayload) return;

      lastPayload = payload;

      // REGULAR: remove additional membership fields
      clearExtraFields();

      if (!needsNewMembership || !isValid) return;

      // VIP: include subscription item in accelerated checkout
      addHiddenField('id', variantId);
      addHiddenField('quantity', '1');
      addHiddenField('selling_plan', sellingPlanId);
    }

    let queued = false;

    function scheduleSync() {
      if (queued) return;

      queued = true;

      queueMicrotask(() => {
        queued = false;
        syncWalletItems();
      });
    }

    // Update when customer switches Regular / VIP
    offer.addEventListener('change', scheduleSync);

    document.addEventListener(
      'vipPricing:changed',
      scheduleSync
    );

    document.addEventListener(
      'vipOffer:stateUpdated',
      scheduleSync
    );

    document.addEventListener(
      'cart:updated',
      scheduleSync
    );

    document.addEventListener(
      'cart:changed',
      scheduleSync
    );

    window.addEventListener('pageshow', scheduleSync);

    // Initial state
    scheduleSync();
  }

  function init(root = document) {
    root.querySelectorAll('[data-frx-wallet]').forEach((wallet) => {
      const form = wallet.closest('form');

      if (form) {
        initForm(form);
      }
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener(
      'DOMContentLoaded',
      () => init(),
      { once: true }
    );
  } else {
    init();
  }

  document.addEventListener(
    'shopify:section:load',
    (event) => init(event.target)
  );
})();